import { render, staticRenderFns } from "./LayoutBackFooter.vue?vue&type=template&id=5450cb48&scoped=true&"
import script from "./LayoutBackFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutBackFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBackFooter.vue?vue&type=style&index=0&id=5450cb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450cb48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5450cb48')) {
      api.createRecord('5450cb48', component.options)
    } else {
      api.reload('5450cb48', component.options)
    }
    module.hot.accept("./LayoutBackFooter.vue?vue&type=template&id=5450cb48&scoped=true&", function () {
      api.rerender('5450cb48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutBackFooter.vue"
export default component.exports